import {
  isValidSequence,
  SANTA_LUCIA_NN,
  SANTA_LUCIA_INIT
} from "./calculateSantaLuciaTm.js";
export default function calculateEndStability(sequence) {
  try {
    sequence = sequence?.toUpperCase().trim();
    if (!isValidSequence(sequence)) {
      throw new Error("Invalid sequence: contains non-DNA characters");
    }
    if (sequence.length < 5) {
      throw new Error(
        "Sequence too short: minimum length is 5 bases for end stability calculation"
      );
    }
    const last5Bases = sequence.substring(sequence.length - 5);
    let deltaH = 0;
    let deltaS = 0;
    for (let i = 0; i < 4; i++) {
      const dinucleotide = last5Bases.substring(i, i + 2);
      if (dinucleotide.includes("N")) {
        continue;
      }
      const params = SANTA_LUCIA_NN[dinucleotide];
      if (params) {
        deltaH += params.dH;
        deltaS += params.dS;
      }
    }
    const firstBase = last5Bases[0];
    const lastBase = last5Bases[last5Bases.length - 1];
    if (firstBase === "G" || firstBase === "C") {
      deltaH += SANTA_LUCIA_INIT.GC.dH;
      deltaS += SANTA_LUCIA_INIT.GC.dS;
    } else {
      deltaH += SANTA_LUCIA_INIT.AT.dH;
      deltaS += SANTA_LUCIA_INIT.AT.dS;
    }
    if (lastBase === "G" || lastBase === "C") {
      deltaH += SANTA_LUCIA_INIT.GC.dH;
      deltaS += SANTA_LUCIA_INIT.GC.dS;
    } else {
      deltaH += SANTA_LUCIA_INIT.AT.dH;
      deltaS += SANTA_LUCIA_INIT.AT.dS;
    }
    const T = 310.15;
    const deltaG = deltaH - T * deltaS / 1e3;
    return Math.round(Math.abs(deltaG) * 100) / 100;
  } catch (e) {
    return `Error calculating end stability for sequence ${sequence}. ${e}`;
  }
}
